var _rect, _rect2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.874512,
    y: 0.583984,
    width: 47.8708,
    height: 47.8708,
    rx: 16,
    fill: "#868686",
    fillOpacity: 0.32
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.874512,
    y: 0.583984,
    width: 47.8708,
    height: 47.8708,
    rx: 16,
    fill: "#323232"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1463 19.4677C31.5449 19.8422 31.5645 20.4688 31.1901 20.8674L23.0712 29.5101L18.4993 25.5096C18.0877 25.1495 18.046 24.5239 18.4062 24.1123C18.7663 23.7007 19.3919 23.659 19.8035 24.0192L22.9367 26.7607L29.7466 19.5115C30.1211 19.1129 30.7477 19.0933 31.1463 19.4677Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBlack);
export default __webpack_public_path__ + "static/media/check-black.22e5853018463cd77cb2ec4249e72cff.svg";
export { ForwardRef as ReactComponent };